import { useContext, useEffect } from "react";
import _ from "lodash";

import io from "socket.io-client";

import HttpContext from "../contexts/HTTP/HttpContext";
import ImageContext from "../contexts/Image/ImageContext";
import ConfigContext from "../contexts/Config/ConfigContext";

function useSocket(props) {
  const { notifications, setNotifications } = props;

  const { post } = useContext(HttpContext);
  const { setImageData } = useContext(ImageContext);
  const { setConfig } = useContext(ConfigContext);

  const handleNotification = (message) => {
    const existingNotifications = _.clone(notifications);
    setNotifications([...existingNotifications, message]);
  };

  const createConnection = async () => {
    // REFACTOR this
    const bytes = new Uint8Array(12);
    crypto.getRandomValues(bytes);
    const key = Array.from(bytes, (byte) =>
      byte.toString(16).padStart(2, "0")
    ).join("");

    await post("/establishConnection", { key });

    const socket = io(process.env.REACT_APP_URL, {
      auth: { token: key },
    });

    socket.on("notification", (data) => {
      const { message } = data;

      const existingNotifications = _.clone(notifications);
      setNotifications([...existingNotifications, message]);
    });

    socket.on("raw-images", (data) => {
      const { imageData: newImageData } = data;

      // Ensure state is updated prior to changing it
      setImageData((imageData) => {
        const updatedImageData = _.cloneDeep(imageData);
        updatedImageData.raw.unshift(...newImageData);

        return updatedImageData;
      });
    });

    socket.on("pending-images", (data) => {
      const { imageData: newImageData } = data;

      // Ensure state is updated prior to changing it
      setImageData((imageData) => {
        const updatedImageData = _.cloneDeep(imageData);
        updatedImageData.processed.unshift(...newImageData);

        return updatedImageData;
      });
    });

    socket.on("processed-images", (data) => {
      const { imageData: newImageData, message } = data;

      // Ensure state is updated prior to changing it

      setImageData((imageData) => {
        const updatedImageData = _.cloneDeep(imageData);
        const imageToUpdate = _.find(updatedImageData.processed, {
          _id: newImageData._id,
        });

        _.assign(imageToUpdate, newImageData);

        return updatedImageData;
      });

      handleNotification(message);
    });

    socket.on("config", (data) => {
      const { config } = data;

      setConfig(config);
    });

    return () => {
      socket.disconnect();
    };
  };

  useEffect(() => {
    (async function () {
      await createConnection();
    })();
  }, []);

  return {};
}

export default useSocket;
